// libraries
import React, { useState, useImperativeHandle, forwardRef } from 'react'
import clsx from 'clsx'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// svg
import { AngleDown } from '/react4xp/components/Svg/Ux/Angle'

export interface AccordionProps {
	title: string
	children: React.ReactNode
	className?: string
}

function Accordion({
	title,
	children,
	className
}: AccordionProps, ref) {

	const [isActive, setIsActive] = useState(false)

    const toggleState = () => {
        setIsActive(prevState => !prevState)
    }

	// expose toggleState and isActive through the ref
	useImperativeHandle(ref, () => ({
		toggle: toggleState,
		open: () => setIsActive(true),
		close: () => setIsActive(false),
		isActive,
	}))

	return (
		<div
			className={clsx(
				'accordion-component',
				isActive && 'accordion-component--active',
				className
			)}
		>

            <button className='accordion-component__title' onClick={toggleState}>

				{isNonWhitespaceString(title) && (
					<span className='text'>
						{title}
					</span>
				)}

                <AngleDown />

            </button>

            <div className='accordion-component__content'>
                <div>
                    <div>
                        {children}
                    </div>
                </div>
            </div>

        </div>
	)
}

export default forwardRef(Accordion)